<div class="component-viewer">
    <div class="row mb-4">
        <div class="col-md-4">
            <mat-card>
                <mat-card-header class="mb-4">
                    <mat-card-title>Today's Bookings</mat-card-title>
                </mat-card-header>
                <mat-card-content class="text-center">
                    <ng-container *ngIf="!isLoading; else loadingTpl">
                        <div class="row">
                            <div class="col-6">
                                <h2>{{todaysBookings}}</h2>
                                <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Total Bookings</p>
                            </div>
                            <div class="col-6">
                                <h2>{{todaysBookingHours | number:'1.0-1'}} hrs</h2>
                                <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Total Hours</p>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-md-4">
            <mat-card>
                <mat-card-header class="mb-4">
                    <mat-card-title>Today's Revenue</mat-card-title>
                </mat-card-header>
                <mat-card-content class="text-center">
                    <ng-container *ngIf="!isLoading; else loadingTpl">
                        <h2>{{todaysRevenue | currency}}</h2>
                        <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Expected Earnings</p>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-md-4">
            <mat-card>
                <mat-card-header class="mb-4">
                    <mat-card-title>Today's Payment Status</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <ng-container *ngIf="!isLoading; else loadingTpl">
                        <div class="row text-center">
                            <div class="col-6">
                                <h2>{{paidBookings}}</h2>
                                <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Paid</p>
                            </div>
                            <div class="col-6">
                                <h2>{{unpaidBookings}}</h2>
                                <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Unpaid</p>
                            </div>
                        </div>
                    </ng-container>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row">
        <div class="col-md-6">
            <mat-card>
                <mat-card-header class="mb-4">
                    <mat-card-title>Overview - 30 Days</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="row text-center">
                        <div class="col-4">
                            <h2>{{overview.booked}}</h2>
                            <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Booked</p>
                        </div>
                        <div class="col-4">
                            <h2>{{overview.cancelled}}</h2>
                            <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Cancelled</p>
                        </div>
                        <div class="col-4">
                            <h2>{{overview.revenue | currency}}</h2>
                            <p [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">Estimated Earnings</p>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

        <div class="col-md-6">
            <mat-card>
                <mat-card-header class="mb-4">
                    <mat-card-title>Recent Activity</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <mat-nav-list class="py-2">
                        <ng-container *ngIf="recentActivity.length > 0; else noActivity">
                            <mat-list-item *ngFor="let activity of recentActivity">
                                <div class="d-flex align-items-center w-100">
                                    <mat-icon class="me-3">event</mat-icon>
                                    <div class="flex-grow-1">
                                        <div class="mat-h3 mb-1">{{activity.name}}</div>
                                        <div [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">{{activity.startTime | date: 'MM/dd/yyyy hh:mm a'}} to {{activity.endTime | date: 'hh:mm a'}} - {{activity.confirmationNumber}} - {{activity.status}}</div>
                                    </div>
                                </div>
                                <mat-divider></mat-divider>
                            </mat-list-item>
                        </ng-container>
                        <ng-template #noActivity>
                            <div class="text-center py-3" [ngClass]="{'text-muted': !isDarkTheme, 'text-muted-dark-mode': isDarkTheme}">
                                No recent activity
                            </div>
                        </ng-template>
                    </mat-nav-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12 col-lg-6 mb-4">
            <mat-card class="h-100">
                <mat-card-header>
                    <mat-card-title>Weekly Bookings ({{currentWeek.startDate}} - {{currentWeek.endDate}})</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-container">
                        <p-chart type="bar" 
                                [data]="weeklyChartData" 
                                [options]="chartOptions">
                        </p-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="col-12 col-lg-6 mb-4">
            <mat-card class="h-100">
                <mat-card-header>
                    <mat-card-title>Monthly Bookings ({{currentMonth}})</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <div class="chart-container">
                        <p-chart type="bar" [data]="monthlyChartData" [options]="chartOptions"></p-chart>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

<ng-template #loadingTpl>
    <div class="loading-container">
        <div class="w-100">
            <div class="d-flex justify-content-center">
                <mat-spinner diameter="40"></mat-spinner>
            </div>
        </div>
    </div>
</ng-template>